import * as searchWidgetActions from './../actions/searchWidgetActions';
import React from 'react';

type inputFilterType = {
  cityMweb: string;
  city: string;
  code: string;
};

type searchWidgetType = {
  isCalendarOpen: boolean;
  fromFilter: inputFilterType;
  toFilter: inputFilterType;
  trainNumber: string;
  toCityNameUsed: string;
  fromCityNameUsed: string;
};

type searchWidgetActionType = {
  type: string;
  data: any;
};

export type searchWidgetContextType = {
  searchWidgetState: searchWidgetType;
  searchWidgetDispatch: React.Dispatch<searchWidgetActionType>;
};

export const searchWidgetInitialState: searchWidgetType = {
  isCalendarOpen: false,
  fromFilter: {
    city: '',
    cityMweb: '',
    code: ''
  },
  toFilter: {
    cityMweb: '',
    city: '',
    code: ''
  },
  trainNumber: '',
  toCityNameUsed: '',
  fromCityNameUsed: ''
};

export const searchWidgetReducer = (state: searchWidgetType, action: searchWidgetActionType) => {
  if (typeof action !== 'object') {
    return state;
  }
  switch (action.type) {
    case searchWidgetActions.ACTION_UPDATE_CALENDAR_OPEN: {
      return {
        ...state,
        isCalendarOpen: action.data
      };
    }
    case searchWidgetActions.ACTION_UPDATE_FROM_STATION_NODE: {
      return {
        ...state,
        fromFilter: action.data
      };
    }
    case searchWidgetActions.ACTION_UPDATE_FROM_CITY_NAME: {
      return {
        ...state,
        fromCityNameUsed: action.data
      };
    }
    case searchWidgetActions.ACTION_UPDATE_TO_STATION_NODE: {
      return {
        ...state,
        toFilter: action.data
      };
    }
    case searchWidgetActions.ACTION_UPDATE_TO_CITY_NAME: {
      return {
        ...state,
        toCityNameUsed: action.data
      };
    }
    case searchWidgetActions.ACTION_UPDATE_TRAIN_NUMBER: {
      return {
        ...state,
        trainNumber: action.data
      };
    }
    default: {
      return state;
    }
  }
};
